import PropTypes from "prop-types";

const propTypes = {
  sprava: PropTypes.shape({
    I_ZP_SPRAVY_UZ: PropTypes.number,
    ZRUS: PropTypes.bool,
    POZN: PropTypes.string,
    TEXT: PropTypes.string,
    I_UZ: PropTypes.number,
    L_PRECITANE: PropTypes.bool,
    D_PRECITANE: PropTypes.instanceOf(Date),
    I_ORGAN: PropTypes.number,
    ADRESAT: PropTypes.string,

    // ZP_SPRAVY data
    I_ZP_SPRAVY: PropTypes.number,
    ZP_SPRAVY_TEXT: PropTypes.string,
    ZP_SPRAVY_D_PUB: PropTypes.instanceOf(Date),
    ZP_SPRAVY_D_DO: PropTypes.instanceOf(Date),
    ZP_SPRAVY_POZN: PropTypes.string,
    ZP_SPRAVY_ZRUS: PropTypes.bool,
  }),
};

export default propTypes;
